import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {
  MatLegacyDialog as MatDialog
 
} from '@angular/material/legacy-dialog';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { MatSort } from '@angular/material/sort';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import {
  IApplication,
  IApplicationInput,
  IUser
} from '@ebb-v2/ebb-integration';
import { ApplicationApiService, AuthenticationService } from '../../data-services';
import { DialogContractorProxyComponent } from '../dialog/dialog-contractorproxy.component';

@Component({
  selector: 'ebb-portal-new-application-list',
  templateUrl: './new-application-list.component.html'
})
export class NewApplicationComponent implements OnInit, OnChanges {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @Input() data: IApplication[] = [];
  @Input() ShowNewApplications: boolean;
  @Input() toggleDisplayCardList: boolean;
  @Input() femareviewmessage: string;
  @Input() currentUser: IUser;
  @Output() emitapplicationChangeEvent = new EventEmitter<boolean>();
  public checkForNewApplications = 'Loading...';
  public cardLayout = 100 / 3 + '%';
  public tablePageSizeOptions: number[] = [10, 25, 50];
  public displayedColumns = [
    'applicationNumber',
    '_Ebb_OwnerId_Formatted',
    'name',
    'acceptedDate',
    'displayretrofitdue',
    '_Ebb_ProgramCycleId_Formatted',
    '_EBB_ProgramType',
    'displaystatus',
    'action'
  ];
  public dataSource: MatTableDataSource<any>;

  public dataSourceLength = 0;
  constructor(
    private readonly apiApplication: ApplicationApiService,
    private readonly authenticationService: AuthenticationService,
    private readonly dialogProxy: MatDialog
  ) {}
  ngOnChanges(): void {
    setTimeout(() => {
      this.dataSource = new MatTableDataSource(this.data);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });
  }

  public ngOnInit() {
    setTimeout(() => {
      this.dataSource = new MatTableDataSource(this.data);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });
  }

  // ACCEPT actionCode == TRUE; REJECT actionCode == FALSE
  public onClickContractorProxy(
    actionCode: boolean,
    applicationId: string
  ): void {
    const dialogRef = this.dialogProxy.open(DialogContractorProxyComponent, {
      width: '325px',
      data: actionCode
    });

    dialogRef.afterClosed().subscribe(result => {
      const applicationUpdate: IApplicationInput = {} as IApplicationInput;

      // Confirm == TRUE; Cancel == FALSE
      if (result) {
        if (actionCode) {
          applicationUpdate.contractorInvitationCode = 700000002;
        } else {
          applicationUpdate.contractorInvitationCode = 700000003;
          applicationUpdate.contractorPermissionsCode = 700000003;
        }
        // console.log(`Proxy action: ${JSON.stringify(applicationUpdate)}`)
        this.apiApplication
          .updateContractorAcceptRejectProject(applicationUpdate, applicationId)
          .subscribe(
            data => {
              // this.ngOnInit();
              this.emitapplicationChangeEvent.emit(true);
            },
            error =>
              console.warn(
                `ERROR: Accept new application ${JSON.stringify(error)}`
              )
          );
      }
    });
  }
  public getFormattedDate(input: any): string {
    if(input == null || input === undefined){
      return "";
    }
    const date =input.toString();
    const permitDateUTC = new Date(date);
    permitDateUTC.setHours(permitDateUTC.getHours() + 8);

    const permitDatePST = new Date(permitDateUTC);

    const year = permitDatePST.getFullYear();

    let month = (1 + permitDatePST.getMonth()).toString();
    month = month.length > 1 ? month : '0' + month;

    let day = permitDatePST.getDate().toString();
    day = day.length > 1 ? day : '0' + day;

    return `${month}/${day}/${year}`;
  }
  public programTypeDesc(programType) {
    switch (programType) {
      case 700000000:
        return 'CEA BB';
        
      case 700000001:
      case 700000002: 
        return 'EBB';
        
      case 700000003:
        return 'ESS';
        
      case 700000004:
        return 'EMR';
        
      default:
        return 'EBB';
    }
  }


  /***     User Convenience Methods */
  public isHomeowner() : boolean {
    return this.authenticationService.isHomeowner(this.currentUser);
  }

  public isContractor(): boolean {
    return this.authenticationService.isContractor(this.currentUser);
  }

  public isInspector() {
    return this.authenticationService.isInspector(this.currentUser);
  }
}
